/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';

import { CheckboxProps as CheckboxPropsType } from '@mui/material';

import { createCheckboxStyles } from './Checkbox.styles';

export function CheckboxProps(): Partial<CheckboxPropsType> {
  const classes = createCheckboxStyles();

  return {
    checkedIcon: <span className={cx(classes.icon, classes.checkedIcon)} />,
    icon: <span className={classes.icon} />,
    disableTouchRipple: true,
  };
}
